import InspirationCollection from './InspirationCollection';

export default InspirationCollection;
